// @ts-check

(() => {
  const setUpHomepageVideoScroll = () => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );
  
    if (prefersReducedMotion.matches) {
      return;
    }

    const videoWrapper = document.querySelector('.homepage-header__video-wrapper');
    if (!(videoWrapper instanceof HTMLElement)) return;

    const updateScale = () => {
      const { y, height } = videoWrapper.getBoundingClientRect();
      const { innerHeight } = window;

      if (y > innerHeight || (y < 0 && Math.abs(y) > height)) return;

      const progress = (1 - ((y + height) / (innerHeight + height)));

      // console.log(progress);

      /*
        Not perfect, but pretty good. To prevent visible layout shift on page-load, though,
        we do have to fade in the element after a small delay (so that this JS has time to
        run first). Right now, we're just doing that with a simple CSS animation.
      */
      const scaleFactor = .8 + progress / 2;

      requestAnimationFrame(() => {
        videoWrapper.style.setProperty('--scale', `${scaleFactor}`);
      });
    };

    window.addEventListener('scroll', updateScale);

    updateScale();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpHomepageVideoScroll);
  } else {
    setUpHomepageVideoScroll();
  }
})();